// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// @ts-ignore
import App from './App'
import router from './routing/router'
// @ts-ignore
import SearchContainer from './components/SearchContainer'

// @ts-ignore
import YouthSelector from './components/youthSelector'
// @ts-ignore
import breadCrumb from './components/navigation/breadcrumb'
// @ts-ignore
import nextSessions from './components/trainingSessions/NextSessions'
// @ts-ignore
import sessionSmall from './components/trainingSessions/session.small'
// @ts-ignore
import exerciseSmall from './components/exercises/exercise.small'
// @ts-ignore
import exerciseMedium from './components/exercises/exercise.medium'
// @ts-ignore
import masterySmall from './components/ballmasteries/masteries.small'
// @ts-ignore
import masterySearch from './components/ballmasteries/masteries.search'
// @ts-ignore
import difficulty from './components/difficulty'
// @ts-ignore
import presenceMembersList from './components/trainingSessions/presence.members.list'
// @ts-ignore
import Datepicker from 'vuejs-datepicker'
// @ts-ignore
import { VueEditor } from 'vue2-editor'
import { ToggleButton } from 'vue-js-toggle-button'
import 'vue-datetime/dist/vue-datetime.css'
// @ts-ignore
import { Settings } from 'luxon'
import apiService from './components/api/apiService'
import moment from 'moment'
// @ts-ignore
import imgComp from './components/medias/image.component'

import { bootstrapPrimeVue } from './bootstrap/primeVueBoot'
// @ts-ignore
import { Datetime as Datetimepicker } from 'vue-datetime'
import VueCookies from 'vue-cookies-ts'
bootstrapPrimeVue()

Settings.defaultLocale = 'de'

export const bus = new Vue()
Vue.config.productionTip = false
Vue.component('sc-media-image', imgComp)
Vue.component('sc-presence-members', presenceMembersList)
Vue.component('ToggleButton', ToggleButton)
Vue.component('sc-search', SearchContainer)
Vue.component('sc-nav-bread', breadCrumb)
Vue.component('sc-youth-select', YouthSelector)
Vue.component('sc-sessions-next', nextSessions)
Vue.component('sc-sessions-small', sessionSmall)
Vue.component('sc-exercise-small', exerciseSmall)
Vue.component('sc-exercise-medium', exerciseMedium)
Vue.component('sc-mastery-small', masterySmall)
Vue.component('sc-mastery-search', masterySearch)
Vue.component('sc-difficulty', difficulty)
Vue.component('sc-date-pick', Datepicker)
Vue.component('sc-date-time-pick', Datetimepicker)
Vue.component('sc-html-editor', VueEditor)

moment.locale('de')

var cookieConsent = {
    created: function () {
    },
    methods: {
        getall: function () {
            return { all: true }
        }
    }
}

var Component = Vue.extend({
  mixins: [cookieConsent]
})

Vue.use(VueCookies)
Vue.filter('formatDate', function (value :any) {
    if (value) {
        return moment(String(value)).calendar(null, {
            lastDay: '[Gestern]',
            sameDay: '[Heute]',
            nextDay: '[Morgen]',
            lastWeek: '[letzter] dddd',
            nextWeek: 'dddd',
            sameElse: 'L'
        })
    }
})

Vue.filter('displayDate', function (value:any) {
    if (value) {
        return moment().format('dddd d. MMM')
    }
})

Vue.filter('img', async function (value:any) {
    if (value) {
        const result = await apiService.getImage(value)
        return result
    }
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App, SearchContainer, nextSessions },
    render: h => h(App)
})
